


import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import MainPagetitle from '../../layouts/MainPagetitle';
import AdminContactService from '../../api/services/AdminContactService';
import CamperService from '../../api/services/CamperService';
import swal from "sweetalert";
const ContactOffcanvas = () => {
    const navigate = useNavigate();

    const [Error, setError] = useState('');

    const [camper, setCamper] = useState([]);
    useEffect(() => {
        if (localStorage.getItem("admintoken")) {
            getCamper();
        }
        else {
            navigate('/')
        }

    }, []);

    const getCamper = async () => {
        try {
            let camper = await CamperService.index().json();
            setCamper(camper.data);

        } catch (error) {
            console.log(error);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            var userData = {
                firstName: event.target.firstName.value,
                camper_id: event.target.camper_id.value,
                email: event.target.email.value,
                phone: event.target.phone.value,
                reasonRequest: event.target.reasonRequest.value,
                message: event.target.message.value,
                bookingNumber: event.target.bookingNumber.value,
                type: event.target.type.value,
                lng: 'en'
            }

            const data = await AdminContactService.store(userData).json();
            if (data.status === true)
                swal("Contact Create Succesfully").then((willDelete) => {
                    if (willDelete) {
                        navigate('/admin/contact')
                    }
                })
            {


            }
        }
        catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();

                setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }


    }
    return (
        <>
            <MainPagetitle mainTitle="Contact" pageTitle={'Contact'} parentTitle={'Home'} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Add Contact</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-xl-6 mb-3">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">First & last name<span className="text-danger">*</span></label>
                                            <input type="text" name="firstName" className="form-control" id="exampleFormControlInput1" placeholder="" />
                                        </div>
                                        <div className="col-xl-6 mb-3">
                                            <label htmlFor="exampleFormControlInput2" className="form-label"> Email <span className="text-danger">*</span></label>
                                            <input type="email" name='email' className="form-control" id="exampleFormControlInput2" placeholder="" />
                                        </div>
                                        <div className="col-xl-6 mb-3">
                                            <label htmlFor="exampleFormControlInput2" className="form-label"> Phone Number <span className="text-danger">*</span></label>
                                            <input type="text" name='phone' className="form-control" id="exampleFormControlInput2" placeholder="" />
                                        </div>
                                        <div className="col-xl-6 mb-3">
                                            <label htmlFor="exampleFormControlInput2" className="form-label"> Booking Number <span className="text-danger">*</span></label>
                                            <input type="text" name='bookingNumber' className="form-control" id="exampleFormControlInput2" placeholder="" />
                                        </div>
                                        <div className="col-xl-6 mb-3">
                                            <label htmlFor="exampleFormControlInput2" className="form-label"> Select Camper <span className="text-danger">*</span></label>
                                            <select className="form-control" id="val-skill" name="camper_id" >
                                                {camper.map((row, index) =>
                                                    <option key={index} value={row.id}>{row.title} </option>
                                                )}
                                            </select>
                                        </div>
                                        <div className="col-xl-6 mb-6">
                                            <label htmlFor="exampleFormControlInput2" className="form-label"> Request For Reason <span className="text-danger">*</span></label>
                                            <select name="reasonRequest" class="form-control">
                                                <option value="Booking Request">Booking Request</option>
                                                <option value="Existing Booking">Existing Booking</option>
                                                <option value="Sunscription">Subscription</option>
                                                <option value="Camper Sale">Camper Sale</option>
                                            </select>
                                        </div>
                                        <div className="col-xl-6 mb-6">
                                            <label htmlFor="exampleFormControlInput2" className="form-label"> Type <span className="text-danger">*</span></label>
                                            <select name="type" class="form-control">
                                                <option value="Contact">Contact</option>
                                                <option value="Sale">Sale</option>
                                                <option value="Travel Planner">Travel Planner</option>
                                                <option value="Login">Login</option>

                                            </select>
                                        </div>
                                        <div className="col-xl-12 mb-3">
                                           
                                        </div>
                                        <div className="col-xl-12 mb-3">
                                            <label htmlFor="exampleFormControlInput2" className="form-label">Message<span className="text-danger">*</span></label>
                                            <textarea rows="2" name='message' className="form-control"></textarea>
                                        </div>
                                      
                                        {Error && <h5 style={{ color: 'red' }}>{Error}</h5>}
                                    </div>
                                    <div>
                                        <button type="submit" className="btn btn-primary me-1">Submit</button>
                                        {/* <Link to={`/admin/contact`} className="btn btn-danger light ms-1">Cancel</Link> */}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};
export default ContactOffcanvas;